/**
 * `/auth-callback`: the MSAL redirectUri, used only as the popup and silent
 * iframe target. Public, outside the shell; renders nothing (PARITY D5).
 */
export function AuthCallbackPage() {
  return null
}
